<div fxLayout="row" fxLayout.xs="column" class="site-layout">
  <div fxFlex="100%;" fxFlex.xs="80%" fxLayout="column" fxLayout.xs="column">
    <div>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h6>Solar Energy Trend</h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          style="align-items: center !important"
          class="site-layout"
        >
          <div fxFlex="10%;" fxFlex.xs="80%" style="text-align: right">
            <mat-label>Select timebase: &nbsp;</mat-label>
          </div>
          <div
            fxFlex="15%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <mat-form-field>
              <mat-select
                [(ngModel)]="timebase"
                (ngModelChange)="onTimeBaseChange()"
              >
                <mat-option
                  *ngFor="let type of timebaseArr"
                  [value]="type.value"
                >
                  {{ type.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="15%;" fxFlex.xs="80%" style="text-align: right">
            <mat-label>Select Date Range:&nbsp;</mat-label>
          </div>
          <div
            fxFlex="45%;"
            fxFlex.xs="80%"
            fxLayout="row"
            fxLayout.xs="column"
            style="align-items: center !important"
          >
            <div>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  [formControl]="startDate"
                  [max]="max"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker1
                  [startView]="startView"
                  (yearSelected)="chosenStartDate_YearHandler($event, picker1)"
                  (monthSelected)="
                    chosenStartDate_MonthHandler($event, picker1)
                  "
                  disabled="false"
                ></mat-datepicker>
                <mat-error *ngIf="startDate.invalid">Invalid Date</mat-error>
              </mat-form-field>
            </div>
            <div style="margin-left: 10px">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  [formControl]="endDate"
                  [max]="max"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker2
                  [startView]="startView"
                  (yearSelected)="chosenEndDate_YearHandler($event, picker2)"
                  (monthSelected)="chosenEndDate_MonthHandler($event, picker2)"
                  disabled="false"
                ></mat-datepicker>
                <mat-error *ngIf="endDate.invalid">Invalid Date</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div
            fxFlex="20%;"
            fxFlex.xs="80%"
            fxLayout="row"
            fxLayout.xs="column"
            style="align-items: center !important"
          >
            <button mat-raised-button (click)="onGenerate()">Generate</button>
            <div>&nbsp;</div>
            <button mat-raised-button (click)="onBack()">Back</button>
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          style="align-items: center !important"
          class="site-layout"
        >
          <div
            fxFlex="10%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          ></div>
          <div
            fxFlex="15%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <mat-checkbox [(ngModel)]="enableShiftwise">
              &nbsp; Show Building wise output</mat-checkbox
            >
          </div>
        </div>
        <div>
          <div [chart]="columnchart"></div>
        </div>
      </mat-expansion-panel>
    </div>
  </div>
</div>
